import { BcModel } from "../models/societe-linked/bc/bc.model";

export class BcValidationModel {
     bc: BcModel;
     commentaire: string;

     constructor(bc: BcModel) {
          this.bc = bc;
          this.commentaire = '';
     }
}
